module.exports = __webpack_public_path__ + "img/profile-img.b6ecb77c.png";